import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Input, Select, Button, List, message, Spin } from 'antd'
import debounce from 'lodash/debounce'
import PosSrc from '../../PosSrc'
import DBService from '../../../../utils/DBService'
import { Context, useStore } from '../../../../context'
import presentationSrc from '../../../products/components/presentationTabs/presentationSrc'
import Utils from '../../../../utils/Utils'
import SuggestedProductsList from './SuggestedProductsList'
import EditComboModal from './EditComboModal'

const { Option } = Select

function SellProductList(props) {
  const [state] = useContext(Context)

  const { hasPermissions } = useStore(state)
  const [productsList, setProductsList] = useState([])
  const [combosList, setCombosList] = useState([])
  const initDataSource = JSON.stringify([{ id: 1, product: null, discount_id: '', discount_amount: '', units: '', price: '', total: 0, type: '', presentation: null }])
  const [dataSource, setDataSource] = useState(JSON.parse(initDataSource))
  const [data, setData] = useState([])
  const [fetching, setFetching] = useState(false)
  const [loading, setLoading] = useState(false)
  const [number, setNumber] = useState(null)
  const [identity, setIdentity] = useState(null)
  const [recipe, setRecipe] = useState({})
  const [suggested, setSuggested] = useState([])
  const [noStock, setNoStock] = useState([])
  const [recipeNoStock, setRecipeNoStock] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)
  const [editComboRowId, setEditComboRowId] = useState(null)

  const { auth } = state

  useEffect(() => {
    props.products(dataSource)

    let total = 0

    dataSource.forEach(d => (total += d.total));

    const amountRecipe = recipe.amount ?? 0

    props.newTotal(total - amountRecipe)
    props.recipe(recipe)
  }, [dataSource, recipe])

  useEffect(() => {
    const productsList = getProductListWithoutStock

    if (props.edit) setDataSource(productsList)

    // fetchPresentations('')
    // eslint-disable-next-line
  }, [props.edit])

  useEffect(() => {
    if (props.isSellCancelled) {
      props.uncancellSell && props.uncancellSell()
      setData([])
      setDataSource(JSON.parse(initDataSource))
    } else {
      fetchProducts()
    }

    return () => {
      setData([])
      setDataSource(JSON.parse(initDataSource))
    }
    // eslint-disable-next-line
  }, [props.isSellCancelled])

  const getProductListWithoutStock = () => {
    return props.productsList.map(obj => {
      const itemsFiltered = props.itemsWithoutStock.filter(
        item => (item.presentations.includes(obj.product))
      )
      return itemsFiltered.length > 0 ? { ...obj, color: 'orange' } : { ...obj, color: '' }
    })
  }

  // Obtener Recetas
  const getRecipes = async () => {
    if (number && identity) {
      setLoading(true)

      PosSrc.getRecipes(number, identity, props.store.id, props.turn.id)
        .then(res => {
          if (res?.data) {
            setDataSource(JSON.parse(initDataSource))

            const withoutStock = res.data.filter(product => {
              if (product.stock <= 0) {
                message.warning(`El producto ${product.description} no tiene existencias`);
                return true;
              }
              return false;
            });

            if (withoutStock.length !== 0) {
              setRecipeNoStock(res.recipe)
              setRecipe(res.recipe);
            }

            const products = res.data.filter(product => product.stock > 0)

            if (products.length !== 0) {
              setDataSource(products);
              setRecipe(res.recipe);
            }

            setNoStock(withoutStock)
          } else {
            message.error(res.errors.message);
          }
          setLoading(false)
        })
        .catch(e => {
          message.error(e)
          setLoading(false)
        })
    }
  }

  const handleOpenDrawer = () => {
    setSuggested([]);
    getSuggestedProducts();
    setShowDrawer(true);
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };
  
  // Productos sugeridos.
  const getSuggestedProducts = async () => {
    
    if (Object.keys(noStock).length > 0) {

      setLoading(true);
      const params = {
        items: noStock,
        recipe: recipeNoStock,
        store_id: props.store.id,
        turn_id: props.turn.id,
      }

      PosSrc.getSuggestedProducts(params)
        .then(res => {
          if (res.length > 0) {
            const products = res.filter(product => {
              if (product.stock <= 0) {
                message.warning(`El producto ${product.description} no tiene existencias`)
              }
              return product.stock > 0
            })

            if (products.length !== 0) {
              setSuggested(products);
            }
          } else {
            message.warning('Sin sugerencias');
          }

          setLoading(false)
        })
        .catch(e => {
          setLoading(false)
          console.log(e)
          message.error('No se ha podido cargar los productos sugeridos')
        })
    }
  }

  const fetchProducts = async () => {
    setLoading(true)
    PosSrc.getAllProducts(props.store.id, props.turn.id)
      .then(async products => {
        if (products.errors?.message[0] === 'Error de conexion') {
          let _productsList = await DBService.getAll('products')
          setProductsList(_productsList)
        } else {
          setProductsList(products.data)
          DBService.add(products.data, 'products')
        }
        fetchCombos()
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar los productos.')
      })
  }

  const fetchCombos = () => {
    PosSrc.getAllCombos(state.auth.company_id)
      .then(async combos => {
        if (combos.errors?.message[0] === 'Error de conexion') {
          let _combosList = await DBService.getAll('combos')
          setCombosList(_combosList)
        } else {
          setCombosList(combos.data)
          DBService.add(combos.data, 'combos')
        }
        setLoading(false)
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar los combos.')
      })
  }

  const onAdd = () => {
    if (Object.keys(recipe).length > 0) {
      return
    }

    setDataSource(prevState => {
      const sorted = prevState.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id ? lastItem.id + 1 : 1 })
      return [...sorted, newRow]
    })
  }

  const onSetProduct = async (product, row) => {
    let typeInfo = product.split('-')
    let productInfo = productsList.find(p => p.id === Number(typeInfo[0]) && p.type === typeInfo[1])
    onSetData(productInfo?.id, row.id, 'product', true)
    onSetData(productInfo?.type, row.id, 'type')
    onSetData(productInfo?.price, row.id, 'price')
    onSetData(row.price * (row.units !== '' ? row.units : 0), row.id, 'total')

    if (productInfo?.type === 'COMBO') {
      // Una selección nueva de combo siempre arranca sin personalizar.
      onSetData(null, row.id, 'kept_presentation_ids')
      onSetData([], row.id, 'combo_extras')
      onSetData(null, row.id, 'presentation')
      return
    }

    const response = await presentationSrc.getPresentation(productInfo.id)
    onSetData(response?.discount_presentation ? response?.discount_presentation : null, row.id, 'presentation')
  }

  const openEditCombo = row => {
    setEditComboRowId(row.id)
  }

  const closeEditCombo = () => {
    setEditComboRowId(null)
  }

  const confirmEditCombo = (rowId, result) => {
    const newDataSource = dataSource.map(row => {
      if (row.id !== rowId) return row
      return {
        ...row,
        kept_presentation_ids: result.kept_presentation_ids,
        combo_extras: result.combo_extras,
        total: result.total,
      }
    })
    setDataSource(newDataSource)
    setEditComboRowId(null)
  }

  const onSetPresentation = (id, row) => {
    const presentationInfo = row.presentation.find(element => element.id === id);
    onSetData(presentationInfo?.id, row.id, 'discount_id')
    onSetData(presentationInfo?.pivot.discount_amount, row.id, 'discount_amount')
    const porcentaje = presentationInfo.pivot.discount_amount
    // const priceUnits = row.price * (row.units !== '' ? row.units : 0)
    // const priceRes = ((porcentaje * priceUnits) / 100)
    // const price = priceUnits - porcentaje * row.units
    const price = calcTotal(row.price, row.units, porcentaje);
    onSetData(price, row.id, 'total')
  }

  const extrasTotalFor = row => (row.combo_extras || []).reduce((acc, e) => acc + e.quantity * e.unit_price, 0)

  const onSetPrice = (e, row) => {
    onSetData(e, row.id)
    if (row.discount_id) {
      const presentationInfo = row.presentation.find(element => element.id === row.discount_id);
      onSetData(presentationInfo?.id, row.id, 'discount_id')
      const porcentaje = presentationInfo.pivot.discount_amount
      // const priceUnits = row.price * (row.units !== '' ? row.units : 0)
      // const priceRes = ((porcentaje * priceUnits) / 100)
      const price = calcTotal(row.price, row.units, porcentaje);
      onSetData(price + extrasTotalFor(row), row.id, 'total')

    } else {
      onSetData(calcTotal(row.price, row.units, 0) + extrasTotalFor(row), row.id, 'total');
    }
  }

  const onSetUnits = (e, row) => {
    onSetData(e, row.id)

    if (row.discount_id) {
      const presentationInfo = row.presentation.find(element => element.id === row.discount_id);
      onSetData(presentationInfo?.id, row.id, 'discount_id')

      const porcentaje = presentationInfo.pivot.discount_amount
      // const priceUnits = row.price * (row.units !== '' ? row.units : 0)
      // const priceRes = ((porcentaje * priceUnits) / 100)
      const price = calcTotal(row.price, row.units, porcentaje);

      onSetData(price + extrasTotalFor(row), row.id, 'total')
    } else {
      onSetData(calcTotal(row.price, row.units, 0) + extrasTotalFor(row), row.id, 'total');
    }
  }

  const onSetData = (e, rowId, name, product = false) => {
    const inputName = name ? name : e.target.name
    const value = name ? e : e.target.value
    let newRow
    if (product) {
      setData([])
      if (name === 'discount_id') {
        newRow = {
          [inputName]: value
        }
      } else {
        newRow = {
          [inputName]: value,
          units: 1,
        }
      }

    } else {
      newRow = { [inputName]: value }
    }

    const newDataSource = dataSource.map(row => {
      if (row.id === rowId) {
        return Object.assign(row, newRow)
      }
      return row
    })
    setDataSource(newDataSource)
  }

  const onDelete = (e, rowId) => {
    if (dataSource.length === 1) return

    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))
      return value
    })
  }

  const fetchPresentations = value => {
    if (value.length >= 3) {
      setData([])
      setFetching(true)
      const excludeChars = Utils.excludedCharsContent(value)
      PosSrc.searchPresentations(props.store.id, props.turn.id, value, excludeChars, 'desc')
        .then(res => {
          if (res.errors?.message[0] === 'Error de conexion') {
            const _value = value.toLowerCase()
            const presentations = productsList.filter(p => p.description.toLowerCase().includes(_value) || p.skus?.toLowerCase().includes(_value))
            const presentationsDescriptions = presentations.map(p => p.description)
            let combos = combosList.filter(c => c.presentations.filter(cp => presentationsDescriptions.includes(cp.description)).length > 0)
            combos = combos.map(c => {
              return {
                id: c.id,
                description: c.description,
                price: c.suggested_price,
                type: 'COMBO',
              }
            })
            const _data = [...presentations, ...combos]
            setData(_data)
          } else {
            const data = res?.data.map(p => ({
              id: p.id,
              description: p.description,
              price: p.price,
              type: p.type,
            }))
            setData(data)
          }
          setFetching(false)
        })
        .catch(e => {
          console.log(e)
          message.error('No se ha podido cargar las presentaciones.')
        })
    } else {
      if (value.length === 0) {
        setData([])
      }
    }
  }

  const handleChange = value => {
    setFetching(false)
  }

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    let n = Number(x) || 0;
    const factor = 10 ** decimalDigits;
    n = Math.round(n * factor) / factor;
  
    if (!returnText) return n;
    return longFixed ? n.toFixed(decimalDigits) : String(n);
  }
  

  // Calcula total = precio * unidades - descuentoPorUnidad * unidades
// usando centavos para evitar errores de 70.96 -> 70.95, etc.
  function calcTotal(price, units, discountPerUnit = 0) {
    const p = Number(price) || 0;
    const u = Number(units) || 0;
    const d = Number(discountPerUnit) || 0;
  
    // trabajamos en centavos
    const priceCents    = Math.round(p * 100);
    const discountCents = Math.round(d * 100);
  
    const totalCents = (priceCents - discountCents) * u;
  
    return totalCents / 100; // regresamos a quetzales/dólares
  }

  return (
    <>
      <Row gutter={24} align="middle" className={'section-space-list-header'}>
        <Col span={5}>
          <h4 className={'section-space-list-bottom'}>Lista de productos</h4>
        </Col>
        <Col span={5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Input
            value={number}
            onChange={e => setNumber(e.target.value)}
            placeholder={'Numero de receta'}
            name={'number'}
            size={'large'}
          />
        </Col>
        <Col span={5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-center' }}>
          <Input
            value={identity}
            onChange={e => setIdentity(e.target.value)}
            placeholder={'Identificación'}
            name={'identity'}
            size={'large'}
          />
        </Col>
        <Col span={5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-center' }}>
          <Button loading={loading} id='ProducSugges' className="title-tendero new-button" onClick={handleOpenDrawer}>
            Sugerenciass
          </Button>
        </Col>
       
      <SuggestedProductsList
        suggestedProducts={suggested}
        dataSource={dataSource}
        storeId={props.store.id}
        setDataSource={setDataSource}
        closable={
          handleCloseDrawer
        }
        loading={loading}
        visible={showDrawer}
      />
        {/* aqui quiero que me llame el componente y aparte me des un modal solo de ejemplo */}
        <Col span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Button loading={loading} htmlType="submit" className="title-tendero new-button" onClick={getRecipes}>
            Buscar
          </Button>
        </Col>
      </Row>
      <List
        id={'inventory-list'}
        size="small"
        rowKey="id"
        dataSource={dataSource}
        renderItem={(row, i) => (
          <List.Item>
            <Row gutter={24} align="bottom" className={'section-space-field w-100'} key={row.id}>
              <Col sm={1}>
                <div className={'title-space-bottom text-bold'}>{i + 1}</div>
              </Col>
              <Col sm={6}>
                {row.id === 1 && <div className={'title-space-field pl-2'}>Productos</div>}
                <Select
                  disabled={loading || row.recipe}
                  loading={loading}
                  autoFocus
                  className={'single-select'}
                  showSearch
                  value={productsList?.find(p => p.id === row.product && p.type === row.type)?.description}
                  placeholder="Nombre o SKU del producto"
                  notFoundContent={fetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  onSearch={debounce(fetchPresentations, 1000)}
                  onChange={e => {
                    handleChange(e)
                    onSetProduct(e, row)
                  }}
                  size={'large'}
                  style={{ width: '100%', color: row.color ? row.color : '' }}
                >
                  {data.map((d, i) => (
                    <Option key={i} value={`${d.id}-${d.type}`}>
                      <span>{d.description}</span>
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col sm={3}>
                {row.id === 1 && <div className={'title-space-field text-center'}>Precio unitario</div>}
                <Input
                  disabled={!row.product ? true : !hasPermissions([51])}
                  value={row.price}
                  onChange={e => onSetPrice(e, row)}
                  placeholder={'Precio'}
                  name={'price'}
                  size={'large'}
                  min="0"
                />
              </Col>
              <Col sm={3}>
                {row.id === 1 && <div className={'title-space-field text-center'}>No. Unidades</div>}
                <Input
                  disabled={(!row.product && true) || row.recipe}
                  value={row.units}
                  onChange={e => onSetUnits(e, row)}
                  placeholder={'No. Unidades'}
                  name={'units'}
                  size={'large'}
                  min="0"
                />
              </Col>
              {auth?.company?.allow_discount_levels === 1 && (
                <Col sm={5}>
                  {row.id === 1 && <div className={'title-space-field text-center'}>Nivel de descuento</div>}
                  <Select
                    disabled={row.presentation?.length === 0 || row.presentation === null || !row.product}
                    autoFocus
                    className={'single-select'}
                    value={row.discount_id}
                    placeholder="Nivel de descuento"
                    filterOption={false}
                    onChange={e => {
                      onSetPresentation(e, row)
                    }}
                    size={'large'}
                    style={{ width: '100%', color: row.color ? row.color : '' }}
                  >
                    {row.presentation && row.presentation.map((d, i) => (
                      <Option key={i} value={d.id}>
                        <span>{`${d.discount_level} - ${d.pivot.discount_amount}`}</span>
                      </Option>
                    ))}
                  </Select>
                </Col>
              )}

              <Col sm={3}>
                {row.id === 1 && <div className={'title-space-field text-center'}>Total</div>}
                <Input
                  style={{ textAlign: 'center' }}
                  disabled={true}
                  value={trunc(row.total)}
                  placeholder={'Q 0.00'}
                  name={'total'}
                  size={'large'}
                  min="0"
                  className="total-product"
                />
              </Col>
              <Col sm={3} className={'center-flex-div'}>
                {row.type === 'COMBO' && (
                  <Button type={'link'} className="title-space-bottom px-0 m-0 mr-2" onClick={() => openEditCombo(row)}>
                    Ver Combo
                  </Button>
                )}
                <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                  Eliminar
                </Button>
              </Col>
            </Row>
          </List.Item>
        )}
        footer={
          <Row gutter={16} className={'section-space-field'}>
            <Col sm={1}></Col>
            <Col sm={9}>
              <div className="title-tendero dashed-border-button" onClick={onAdd}>
                <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                  <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                </svg>
                <span className={'text'}>Agregar Producto</span>
              </div>
            </Col>
            {Object.keys(recipe).length > 0 && (
              <Col sm={6}>
                <div>
                  Monto Receta: <span>{props.symbol} {trunc(recipe.amount)}</span>
                </div>
              </Col>
            )}
          </Row>
        }
      />
      {editComboRowId && (
        <EditComboModal
          visible={!!editComboRowId}
          row={dataSource.find(r => r.id === editComboRowId)}
          comboDefinition={productsList.find(c => c.type === 'COMBO' && c.id === dataSource.find(r => r.id === editComboRowId)?.product)}
          storeId={props.store.id}
          turnId={props.turn.id}
          symbol={props.symbol}
          onClose={closeEditCombo}
          onConfirm={result => confirmEditCombo(editComboRowId, result)}
        />
      )}
    </>
  )
}

export default SellProductList
